import { render, staticRenderFns } from "./transfer-form.vue?vue&type=template&id=583e848b&"
import script from "./transfer-form.vue?vue&type=script&lang=js&"
export * from "./transfer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports